import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { BlockItem } from 'src/app/admin/models/admin.model';
import { Cart, CartItem, Order } from 'src/app/cart/cart.model';
import { GUID } from 'src/app/core/types';
import { FieldConfig } from 'src/app/generic-fields/generic-fields';

export const KeepAlive = createAction(
  '[Cart] Keep Alive'
)

export const LoadCart = createAction(
  '[Cart] Load Cart',
  (payload: { orderId?: GUID } = {}) => payload // defined optional payload
)

export const LoadCartSuccess = createAction(
  '[Cart] Cart Loaded Success',
  props<{ cart: Cart }>()
)

export const LoadCartFailure = createAction(
  '[Cart] Cart Loaded Failure',
  props<{ error: HttpErrorResponse }>()
)

export const EditReservation = createAction(
  '[Cart] Edit Reservation',
  props<{ cartItem: CartItem | BlockItem | null }>()
)

export const CopyReservation = createAction(
  '[Cart] Copy Reservation',
  props<{ cartItem: CartItem }>()
)

export const SelectItemInObjectChoice = createAction(
  '[Cart] Select Item in ObjectChoice',
  props<{ itemId: number }>()
)

export const LoadOrder = createAction(
  '[Cart] Load Order'
)

export const LoadOrderSuccess = createAction(
  '[Cart] Load Order Success',
  props<{ order: Order }>()
)

export const LoadCheckoutFields = createAction(
  '[Cart] Load Checkout-Fields'
)

export const LoadCheckoutFieldsSuccess = createAction(
  '[Cart] Load Checkout-Fields Success',
  props<{ checkoutFields: FieldConfig[] }>()
)

export const SaveOrder = createAction(
  '[Cart] Save Order',
  props<{ sendStatusMailToCustomer?: boolean }>()
)

export const SaveOrderSuccess = createAction(
  '[Cart] Save Order Success'
)

export const SaveOrderError = createAction(
  '[Cart] Save Order Error',
  props<{ error: any }>()
)
